import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import ModalDialog from '../ui/modal-dialog';
import DataTable from '../ui/table';
import RelatedEditor from './relatedEditor'; // api
// import { getLogistics } from '../../api/freightAPI'

var gt = i18n.getFixedT(null, 'app');
var LogisticsRelated = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      logisticsList = _useSelector.app.logisticsList;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      logistics = _useState2[0],
      setLogistics = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      editData = _useState4[0],
      setEditData = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      keyword = _useState8[0],
      setKeyword = _useState8[1];

  var id = props.id,
      onClose = props.onClose,
      isOpen = props.isOpen;
  var isScrollBottom = useRef(false);

  var handleClose = function handleClose() {
    if (!_.isEmpty(editData)) return null;
    onClose();
  };

  var handleCloseEdit = function handleCloseEdit() {
    setEditData(null);
  };

  var handleEdit = function handleEdit(row) {
    setEditData({
      id: row.value,
      name: row.text
    });
  };

  var handleScrollEvent = function handleScrollEvent(e) {
    if (isScrollBottom.current === true) return;

    if (e.target.clientHeight + e.target.scrollTop + 200 >= e.target.scrollHeight) {
      setPage(page + 1);

      var data = _.filter(logisticsList, function (el) {
        return el.text.indexOf(keyword) >= 0;
      });

      data = _.slice(data, 0, (page + 1) * 100);
      setLogistics(data);
      if (logistics.length === logisticsList.length) isScrollBottom.current = true;
    }
  };

  useEffect(function () {
    if (!isOpen) return;

    var data = _.slice(logisticsList, 0, 100);

    setLogistics(data);
  }, [isOpen]);
  useEffect(function () {
    if (keyword === '') setPage(1);
    if (!isOpen || _.isEmpty(logisticsList)) return;

    var data = _.filter(logisticsList, function (el) {
      return el.text.indexOf(keyword) >= 0;
    });

    data = _.slice(data, 0, (page + 1) * 100);
    setLogistics(data);
    isScrollBottom.current = false;
  }, [keyword]);
  var fields = {};

  _.set(fields, 'text', {
    label: gt('system.logistics')
  });

  _.set(fields, 'setting', {
    label: gt('system.edit'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: gt('system.edit'),
        onClick: function onClick() {
          return handleEdit(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-pencil-alt fa-list-alt"
      })));
    }
  });

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  }); // if(_.isEmpty(logisticsList))
  //     return null


  if (isOpen === false) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: gt('system.logistics-related-setting'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement("input", {
    value: keyword,
    onChange: function onChange(e) {
      return setKeyword(e.target.value);
    },
    placeholder: 'Search'
  }), /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: logistics,
    containerOnScroll: function containerOnScroll(e) {
      return handleScrollEvent(e);
    }
  }))), !_.isEmpty(editData) && /*#__PURE__*/React.createElement(RelatedEditor, {
    contextRoot: contextRoot,
    editData: editData,
    type: 'logistics',
    onClose: handleCloseEdit
  }));
});
LogisticsRelated.defaultProps = {
  id: 'g-logisticsRelated-related-editor'
};
LogisticsRelated.propTypes = {
  id: PropTypes.string
};
export default LogisticsRelated;